export default {
  setSelectedProduct({ commit }, payload) {
    commit("SET_SELECTED_PRODUCT", payload);
  },
  setPreSelectedProduct({ commit }, payload) {
    commit("SET_PRE_SELECTED_PRODUCT", payload);
  },
  productSelectionCompleted({ commit }, payload) {
    commit("SET_SELECTED_PRODUCT", payload);
    commit("SET_PRE_SELECTED_PRODUCT", null);
  },
  addToCart({ commit }, payload) {
    commit("ADD_TO_CART", payload);
  },
  updateToCart({ commit }, payload) {
    commit("UPDATE_TO_CART", payload);
  },
  removeEntryFromCurrentCart({ commit }, payload) {
    commit("REMOVE_ENTRY_FROM_CART", payload);
  },
  createNewCart({commit},payload){
    commit("CREATE_NEW_CART",payload);
  },
  removeCart({commit},payload){
    commit("REMOVE_THE_CART",payload);
  },
  setCurrentCart({commit},payload){
    commit("SET_CURRENT_CART",payload);
  },
  setScreenLock({commit},payload){
    commit("SET_SCREEN_LOCK",payload);
  },
  setIsLoading({commit},payload){
    commit("SET_IS_LOADING",payload);
  },
  setActivePersonal({commit},payload){
    commit("SET_ACTIVE_PERSONAL",payload);
  },
  setPersonList({commit},payload){
    commit("SET_PERSON_LIST",payload);
  },
  setToUpdateEntry({commit},payload){
    commit("SET_UPDATE_ENTRY",payload);
  },
  setIsReset({commit},payload){
    commit("SET_IS_RESET",payload);
  },
  setLastBillId({commit},payload){
    commit("SET_LAST_BILL_ID",payload)
  },
  setPaymentMethods({commit},payload){
    commit("SET_PAYMENT_METHODS",payload);
    commit("SET_SELECTED_PAYMENT_METHOD",payload[0]);
  },
  setSelectedPaymentMethod({commit},payload){
    commit("SET_SELECTED_PAYMENT_METHOD",payload);
  },
  setActivePersonalUserCode({commit},payload){
    commit("SET_ACTIVE_PERSONAL_USER_CODE",payload);
  },
  setLossMode({commit},payload){
    commit("SET_LOSS_MODE",payload);
  },
  setLossType({commit},payload){
    commit("SET_LOSS_TYPE",payload);
  },
  addSelectedLossStock({commit},payload){
    commit("ADD_SELECTED_LOSS_STOCK",payload);
  },
  clearSelectedLossStocks({commit}){
    commit("CLEAR_SELECTED_LOSS_STOCKS")
  },
  removeSelectedLossStock({commit},payload){
    commit("REMOVE_SELECTED_LOSS_STOCK",payload);
  },
  setCakeQuestioned({commit},payload){
    commit("SET_CAKE_QUESTIONED",payload);
  },
  setCurrentCartCustomer({commit},payload){
    commit("SET_CURRENT_CART_CUSTOMER",payload);
  },
  setCurrentCartWithCampaign({commit},payload){
    commit("SET_CURRENT_CART_WITH_CAMPAIGN",payload);
  },
  setNavigationQuestion({commit}, payload) {
    commit("SET_NAVIGATION_QUESTION", payload);
  },
  hasNeedNavigationByQuestion({commit}, payload) {
    commit("HAS_NEED_NAVIGATION_BY_QUESTION", payload)
  },
  setCurrentCartNavigatedByQuestion({commit}) {
    commit("SET_CURRENT_CART_NAVIGATED_BY_QUESTION")
  },
  setNotifications({commit},payload){
    commit("SET_NOTIFICATIONS",payload);
  }
};
